import { useAuth } from '../contexts/AuthContext';
import { useVendorSubscriptionFeatures } from '../services/subscriptionService';
import { isVendorPathAllowed } from '../utils/vendorPlanAccess';

const useVendorPlanAccess = () => {
  const { user } = useAuth();
  const isVendor = user?.user_type === 'vendor';

  const { isLoading, hasActiveSubscription, currentSubscription } = useVendorSubscriptionFeatures(null, {
    enabled: isVendor,
  });

  const vendorPageAccess = currentSubscription?.vendor_page_access ?? null;
  const isFreeTier = Boolean(currentSubscription?.is_free_tier);
  const currentPlanSlug = currentSubscription?.plan_slug ?? null;

  const canAccessPath = (pathname) =>
    isVendorPathAllowed(pathname, vendorPageAccess, hasActiveSubscription !== false);
  const canAccessKey = (key) => {
    if (!Array.isArray(vendorPageAccess) || vendorPageAccess.length === 0) return true;
    return vendorPageAccess.includes(key);
  };

  return {
    isLoading: isVendor ? isLoading : false,
    hasActiveSubscription,
    vendorPageAccess,
    currentSubscription,
    isFreeTier,
    currentPlanSlug,
    canAccessPath,
    canAccessKey,
  };
};

export default useVendorPlanAccess;
